export default {
  user: {
    profile: "윤곽",
    user: "사용자",
    users: "사용자",
    user_list: "사용자 목록",
    role_list: "역할 목록",
    username: "사용자 이름",
    name: "성명",
    email: "이메일",
    phone: "전화",
    add: "사용자 추가",
    password: "암호",
    repeat_password: "반복 암호",
    login: "로그인",
    department: "학과",
    position: "위치",
    contact: "연락처 정보"
  }
};
